import React, { useContext } from "react";
import { BuildingsContext } from "../../../bContext";
import "./WycFour.scss";

import one from "../../../assets/wycieczka/Four/1.jpg";
import two from "../../../assets/wycieczka/Four/2.jpg";
import three from "../../../assets/wycieczka/Four/3.jpg";
import four from "../../../assets/wycieczka/Four/4.jpg";
import five from "../../../assets/wycieczka/Four/5.jpg";

import oneEn from "../../../assets/wycieczka/Four/1en.jpg";
import twoEn from "../../../assets/wycieczka/Four/2en.jpg";
import threeEn from "../../../assets/wycieczka/Four/3en.jpg";
import fourEn from "../../../assets/wycieczka/Four/4en.jpg";
import fiveEn from "../../../assets/wycieczka/Four/5en.jpg";

import m4 from "../../../assets/wycieczka/xsounds/04.mp3";
import m4En from "../../../assets/wycieczka/xsounds/04en.mp3";
import Sound from "react-sound";

function WycFour() {
  const {
    wycPlay,
    setWycPlay,
    speakVol,
    setWycStop,
    switchToEnglish,
  } = useContext(BuildingsContext);

  return (
    <div className="wycFour">
      <Sound
        url={!switchToEnglish ? m4 : m4En}
        playStatus={wycPlay}
        onFinishedPlaying={() => {
          setWycPlay(Sound.status.STOPPED);
          setWycStop(true);
        }}
        volume={speakVol}
      />
      <div className="title-wyc">
        {!switchToEnglish ? (
          <>
            <img className="one" src={one} alt="" />
            <img className="two" src={two} alt="" />
          </>
        ) : (
          <>
            <img className="one" src={oneEn} alt="" />
            <img className="two" src={twoEn} alt="" />
          </>
        )}
      </div>

      {!switchToEnglish ? (
        <>
          <img className="three" src={three} alt="" />
          <img className="four" src={four} alt="" />
          <img className="five" src={five} alt="" />
        </>
      ) : (
        <>
          <img className="three" src={threeEn} alt="" />
          <img className="four" src={fourEn} alt="" />
          <img className="five" src={fiveEn} alt="" />
        </>
      )}
    </div>
  );
}

export default WycFour;
